import { Link, useLocation } from "react-router-dom";

import { motion } from "framer-motion";

function NavLink({ label = "", to = "/", isActive = false }) {
  return (
    <Link to={to} className="flex items-center gap-x-2 group">
      <p>{label}</p>
      <div className="w-6 desktop:w-12">
        <motion.div
          className={`transition-all duration-200 ease h-3 bg-chocolate desktop:h-4 ${
            !isActive && "group-hover:w-6"
          }
          ${
            isActive === true
              ? "w-8 tablet:w-10 desktop:w-12 duration-200"
              : "w-3 desktop:w-4"
          }
          `}
        ></motion.div>
      </div>
    </Link>
  );
}

export default function Nav() {
  const location = useLocation();

  const navItems = [
    {
      label: "Schedule",
      to: "/",
    },
    {
      label: "Interview",
      to: "/interviews",
    },
    {
      label: "About",
      to: "/about",
    },
  ];

  return (
    <nav
      className="flex font-apfelgrotezk bg-strawberry bg-opacity-80 text-xs tablet:text-base desktop:text-lg justify-between 
      px-3 py-4 sm:px-4 sm:pt-8 fixed left-0 right-0 top-0 z-50 desktop:px-8"
    >
      <div className="flex gap-x-4 tablet:gap-x-16 uppercase">
        {navItems.map((item) => (
          <NavLink
            label={item.label}
            to={item.to}
            key={item.to}
            isActive={item.to === location.pathname}
          />
        ))}
      </div>
      <motion.a
        href="https://www.eventbrite.ca/e/536551890147/"
        target="_blank"
        className="bg-transparent hover:bg-chocolate hover:text-strawberry transition-all duration-300 border border-chocolate text-[20px] p-[8px] hidden desktop:inline-block"
      >
        BUY TICKETS
      </motion.a>
    </nav>
  );
}
